import { render, staticRenderFns } from "./CarouselPage.vue?vue&type=template&id=371377b6&scoped=true&"
import script from "./CarouselPage.vue?vue&type=script&lang=js&"
export * from "./CarouselPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371377b6",
  null
  
)

export default component.exports